package twist.mena.sports.shared.dto.admin.legacy

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UpdateLegacyEntityRequest(
    @SerialName("name_en") val nameEn: String? = null,
    @SerialName("name_ar") val nameAr: String? = null,
    @SerialName("display_order") val displayOrder: Int? = null
)
